import React, { ReactElement, useRef } from "react";

import { cn } from "../../../services/common/className";

import "./accountDetailsCard.scss";

export interface AccountDetailsCardProps {
  icon: ReactElement | string;
  title: string;
  link?: ReactElement;
  mods?: {};
  mix?: string;
  scrollable?: boolean;
  contentWidth?: number | null;
};

const AccountDetailsCard: React.FC<AccountDetailsCardProps> = (props) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const scroll = contentRef.current && props.contentWidth && contentRef.current.offsetWidth < props.contentWidth;

  return (
    <div className={cn("account-details__card")(props.mods, props.mix)}>
      <div className="account-details__card__header account-details__card__row">
        <div className="account-details__card__item">
          <div className="account-details__card__icon">
            {props.icon}
          </div>
          <div className="account-details__card__title">
            {props.title}
          </div>
        </div>

        <div className="account-details__card__item">
          {props.link}
        </div>
      </div>
      <div ref={contentRef} className={cn("account-details__card__content")({ scrollable: !!props.scrollable, scroll: !!scroll })}>
        {props.children}
      </div>
    </div>
  );
};

export default AccountDetailsCard;